import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getParticipants, deleteParticipant } from '../../../../api/participant'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import { getGroups } from '../../../../api/group'
import { getGames } from '../../../../api/game'

function getData(participants, groups, games) {
  let data = []
  for (let i = 0; i < participants.length; ++i) {
      const elem = {}
      elem.name = participants[i].fullName
  		elem.group = participants[i].group
  			? groups.find((cat) => cat._id === participants[i].group)?.fullName
  			: '---';
      let gameid = participants[i].group
  			? groups.find((cat) => cat._id === participants[i].group)?.game
  			: '---';
      elem.game = gameid
  			? games.find((cat) => cat._id === gameid)?.fullName
  			: '---';
      elem.createdAt = participants[i].createdAt
      elem.id = participants[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function ParticipantsPage() {
  const [data, setData] = useState([])
  const [participantId, setParticipantId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-participant/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setParticipantId(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }


  const columns = [
    { dataField: 'name', text: 'Full name', sort: true },
    { dataField: 'group', text: 'Group', sort: true },
    { dataField: 'game', text: 'Game', sort: true },
    { dataField: 'createdAt', text: 'Created at', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getParticipants().then((res) => {
      if (res.status === 200) {
        getGroups().then((respGroups) => {
          if (respGroups.status === 200) {
            getGames().then((respGames) => {
              if (respGames.status === 200) {
                setData(getData(res.data, respGroups.data, respGames.data))
                setRefresh(false)
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'Could not get games.' })
            })
          }
        }).catch(error => {
          alertError({ error: error, customMessage: 'Could not get groups.' })
        })
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get participants.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Participants list'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/edit-participant')}
              >
                Add new
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={'Are you sure you want to remove this participant?'}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteParticipant(participantId).then(res => {
                if (res.status === 204) {
                  alertSuccess({  title: 'Deleted!', customMessage: 'Participant removed successfully.' })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: 'Could not remove participant.' })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
